import React, { useState } from "react";
import styles from "./styles.module.scss";
import formStyles from "./../form.module.scss";
import classnames from "classnames";
import iconPencil from "assets/icons/pencil.svg";
import { Link } from "react-router-dom";
import { CompanyId, CompanyPortId, Terminal } from "../../types/company";
import { Button } from "../Button";

import * as H from "history";
import ReactModal from "react-modal";
import iconTrash from "../../assets/icons/trash.svg";
import { deleteTerminal } from "../../api/terminal";
import { showError } from "../../utils/error";

interface Props {
  history: H.History;
  reload: () => void;
  terminals: Terminal[];
  companyId: CompanyId;
  companyPortId: CompanyPortId;
}
const Terminals = (props: Props) => {
  const [deletableTerminal, setDeletableTerminal] = useState<Terminal>();

  if (!props.terminals) {
    return null;
  }

  const terminals = props.terminals.sort((a, b) =>
    a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
  );

  const addTerminalPage = () => {
    props.history.push(
      `/terminal/new/${props.companyId}/${props.companyPortId}`
    );
  };

  return (
    <>
      <ul className={styles.innerRowHeader}>
        <li>Name</li>
        <li>Berths</li>
        <li className={classnames(styles.actionColumn)}>Action</li>
      </ul>
      {terminals.map((terminal, index) => (
        <ul key={index} className={classnames(styles.innerRow)}>
          <li>{terminal.name}</li>
          <li>
            {terminal.berths
              .map(t => t.name)
              .sort()
              .join(", ")}
          </li>
          <li className={classnames(styles.actionColumn)}>
            <Link
              to={`/terminal/edit/${props.companyId}/${props.companyPortId}/${terminal.id}`}
            >
              <img src={iconPencil} alt="" />
            </Link>
            <img
              src={iconTrash}
              alt=""
              onClick={() => setDeletableTerminal(terminal)}
            />

            {deletableTerminal && (
              <ReactModal
                isOpen={true}
                contentLabel="Delete"
                className={styles.modal}
                overlayClassName={styles.modalOverlay}
              >
                <p>
                  Are you sure you want to delete terminal{" "}
                  {deletableTerminal.name}?
                </p>
                <div>
                  <Button
                    className={classnames(styles.modalButton)}
                    onClick={() => setDeletableTerminal(undefined)}
                  >
                    Cancel
                  </Button>
                  <Button
                    className={classnames(styles.modalButton)}
                    onClick={() =>
                      deleteTerminal(deletableTerminal.id).then(b => {
                        if (b.type === "success") {
                          setDeletableTerminal(undefined);
                          props.reload();
                        } else {
                          showError(b.msg);
                        }
                      })
                    }
                  >
                    Delete
                  </Button>
                </div>
              </ReactModal>
            )}
          </li>
        </ul>
      ))}
      <br />
      <form onSubmit={() => addTerminalPage()} className={formStyles.inputForm}>
        <Button type="submit" className={formStyles.inputButton}>
          Add terminal
        </Button>
      </form>
    </>
  );
};

export default Terminals;
